import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import Slide from 'material-ui/transitions/Slide';

import { find, push } from 'lodash'

import * as toaster from '../../../actions/toaster';
import MultiSelect from '../../multiselect'
// import { connect } from 'http2';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class AddRole extends Component {
    state = {
        open: false,
        addRole: {
            committee_id: '',
            role: [],
        }
    };

    handleChange = event => {
        let newaddRole = Object.assign({}, this.state.addRole);
        newaddRole.committee_id = event.target.value;
        this.setState({ addRole: newaddRole });
    };
    handleMultiSelectChange = event => {
        let newaddRole = Object.assign({}, this.state.addRole);
        newaddRole.role = event.target.value;
        this.setState({ addRole: newaddRole });
    };
    handleRequestClose = () => {
        this.state.addRole = { committee_id: '', role: [], }
        this.setState({ open: false });
    };

    setData = () => {
        if ((this.state.addRole.committee_id.length > 0 || this.state.addRole.committee_id > 0) && this.state.addRole.role.length > 0) {
            // let roles=this.state.addRole.role;
            // this.state.addRole.role=roles.split(',')
            // push(this.state.addRole.role,roles)
            this.setState({ open: false });
            // console.log('addRole',this.state.addRole)
            this.props.setAddRoleData(this.state.addRole);
            this.state.addRole = {
                committee_id: '',
                role: [],
            }
        }
        else
            this.props.actions.warningToasters('Team and Role are mandatory');
    };
    render() {
        const { roleList, committeeList } = this.props;
        let _roleList = null
        // console.log('AddRole roleList',roleList)
        if (roleList && roleList.length > 0) {
            _roleList = roleList.map(role => ({ value: role.id, label: role.name }))
        }
        let _TeamList = null
        // console.log('AddRole TeamList', roleList)
        // console.log('AddRole TeamList', committeeList)
        if (committeeList && committeeList.length > 0) {
            _TeamList = committeeList.map(team => (
                <MenuItem key={team.id} value={team.id}
                    style={{ fontWeight: '500', }}>
                    {team.name}
                </MenuItem>
            ))
        }
        return (
            <div>
                <Button variant="raised" className="bg-primary text-white" onClick={() => this.setState({ open: true })}>Add Role</Button>
                <Dialog open={this.state.open} transition={Slide} onClose={this.handleRequestClose}>
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Assign Role</span>
                    </DialogTitle>
                    <DialogContent>
                        <div className="row p-4">
                            <div className="col-md-12">
                                Please select the required team and corresponding Roles to be added
                                <FormControl className="w-100 mb-2 col-md-12">
                                    <InputLabel htmlFor="age-simple">Team</InputLabel>
                                    <Select
                                        value={this.state.addRole.committee_id}
                                        onChange={this.handleChange}
                                        input={<Input id="age-simple" />}
                                    >
                                        {_TeamList}
                                    </Select>
                                </FormControl>
                                <MultiSelect label="Add Roles" className="addrole" options={_roleList} onChange={(data) => { this.state.addRole.role = data }} value={this.state.addRole.role} />
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.setData} variant="raised" className="jr-btn bg-primary text-white">Add Role</Button>
                        <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Cancel</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return state;
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(toaster, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddRole);


// WEBPACK FOOTER //
// ./app/userdetails/adduser/addrole.js